import axios from 'axios'
import cheerio from 'cheerio'
import config from '~/app.config.js'

export const getGroupFromTG = async function (PRE_URL, isIdLink, groupKey) {
  const res = await axios.get(isIdLink ? ('http://0.plus/tme/joinchat/' + groupKey) : ('http://0.plus/tme/' + groupKey), {
    dataType: 'html',
    ContentType: 'application/html;charset=UTF-8',
    headers: {
      'accept-language': 'zh-CN'
    }
  })
  const $ = cheerio.load(res.data)
  const groupName = $('html body .tgme_page_title').first() && $('html body .tgme_page_title').first().text() || ''
  const extraInfo = $('html body .tgme_page_extra').first().html() && $('html body .tgme_page_extra').first().html().replace(/Telegram/, 'Íšôł').replace(/https\:\/\/t\.me/, 'http://0.plus') || ''
  let imgSrc = $('html body img').first() && $('html body img').first().attr('src') || ''
  let desc = $('html body .tgme_page_description').first().html() && $('html body .tgme_page_description').first().html().replace(/Telegram/, 'Íšôł').replace(/https\:\/\/t\.me/, 'http://0.plus').replace(/tg\:\/\//, 'btcchat://') || ''
  let descNoInfo = desc
  if (desc.toLowerCase().includes('if you have <strong>biyong</strong>')) {
    desc = ''
  } else {
    descNoInfo = ''
  }
  if (imgSrc) {
    const reg = /^https:\/\/(\w+)\..+(\/file\/.+)$/g
    const result = reg.exec(imgSrc)
    const requestLogoUrl = 'http://0.plus/' + result[1] + result[2]
    imgSrc = requestLogoUrl
  }
  const groupInfo = {}
  groupInfo.groupName = decodeURIComponent(groupName.trim())
  groupInfo.imgSrc = imgSrc
  groupInfo.extraInfo = extraInfo
  groupInfo.desc = desc
  groupInfo.descNoInfo = descNoInfo
  groupInfo.groupKey = groupKey
  // groupInfo.GROUP_URL = NAME_PRE_URL + groupKey
  groupInfo.GROUP_URL = PRE_URL + groupKey;
  groupInfo.path = 'joinchat/' + groupKey
  // groupInfo.status = ""
  // groupInfo.bigV = "NORMAL"
  if (groupInfo.groupName) { // groupKey 是乱写的，获取不到 groupName
    return groupInfo;
  } else {
    return null
  }
}

export const getGroup = async function (PRE_URL, groupKey) {
  const { data: groupData } = await axios.get(config.apiDomain + '/t-group/find/v2?groupKey=' + groupKey)
  if (groupData.data && groupData.code === 200) {
    let groupName = groupData.data.groupName
    let imgSrc = groupData.data.groupLogo
    let extraInfo = groupData.data.groupNumber ? `${groupData.data.groupNumber} members` : ''
    let desc = groupData.data.groupInfo ? groupData.data.groupInfo.replace(/Telegram/, 'Íšôł').replace(/https\:\/\/t\.me/, 'http://0.plus') : ''
    const groupInfo = {}
    groupInfo.groupName = decodeURIComponent(groupName)
    groupInfo.imgSrc = imgSrc
    groupInfo.extraInfo = extraInfo
    groupInfo.desc = desc
    groupInfo.groupKey = groupKey
    // groupInfo.GROUP_URL = NAME_PRE_URL + groupKey
    groupInfo.GROUP_URL = PRE_URL + groupKey;
    groupInfo.path = 'joinchat/' + groupKey
    groupInfo.status = groupData.data.status
    groupInfo.bigV = groupData.data.bigV
    return groupInfo
  } else {
    return null
  }
}


export const textBecomeImg = function(text, fontsize, fontcolor) {
  let textWidth = 70;
  if (text.length < 10) {
    textWidth = 50;
  }
  if (text.length > 20) {
    textWidth = 130;
  } else if (text.length > 40) {
    textWidth = 170;
  }

  var canvas = document.createElement("canvas");
  //小于32字加1  小于60字加2  小于80字加4    小于100字加6
  var $buHeight = 0;
  if (fontsize <= 32) {
    $buHeight = 1;
  } else if (fontsize > 32 && fontsize <= 60) {
    $buHeight = 2;
  } else if (fontsize > 60 && fontsize <= 80) {
    $buHeight = 4;
  } else if (fontsize > 80 && fontsize <= 100) {
    $buHeight = 6;
  } else if (fontsize > 100) {
    $buHeight = 10;
  }
  //对于g j 等有时会有遮挡，这里增加一些高度
  canvas.height = fontsize + $buHeight + 10;
  var context = canvas.getContext("2d");
  // 擦除(0,0)位置大小为200x200的矩形，擦除的意思是把该区域变为透明
  context.clearRect(0, 0, canvas.width, canvas.height);
  context.fillStyle = fontcolor;
  context.font = fontsize + "px Arial";
  //top（顶部对齐） hanging（悬挂） middle（中间对齐） bottom（底部对齐） alphabetic是默认值
  context.textBaseline = "top";
  context.fillText(text, 0, fontsize / 2);

  //如果在这里直接设置宽度和高度会造成内容丢失 , 暂时未找到原因 , 可以用以下方案临时解决
  //canvas.width = context.measureText(text).width;

  //方案一：可以先复制内容  然后设置宽度 最后再黏贴
  //方案二：创建新的canvas,把旧的canvas内容黏贴过去
  //方案三： 上边设置完宽度后，再设置一遍文字

  //方案一： 这个经过测试有问题，字体变大后，显示不全,原因是canvas默认的宽度不够，
  //如果一开始就给canvas一个很大的宽度的话，这个是可以的。
  //var imgData = context.getImageData(0,0,canvas.width,canvas.height);  //这里先复制原来的canvas里的内容
  //canvas.width = context.measureText(text).width;  //然后设置宽和高
  //context.putImageData(imgData,0,0); //最后黏贴复制的内容

  //方案三：改变大小后，重新设置一次文字
  canvas.width = context.measureText(text).width;
  context.fillStyle = fontcolor;
  context.font = fontsize + "px Arial";
  context.textBaseline = "top";
  context.fillText(text, 0, fontsize / 2);

  var dataUrl = canvas.toDataURL("image/png"); //注意这里背景透明的话，需要使用png
  return dataUrl;
}

//绘制文字到canvas，判断换行位置，和设置canvas高度
export const canvasWrapText = function(options) {
  var settings = {
    canvas: document.createElement("canvas"), //canvas对象，必填，不填写默认找到页面中的第一个canvas
    canvasWidth: 320, //canvas的宽度
    drawStartX: 5, //绘制字符串起始x坐标
    drawStartY: 20, //绘制字符串起始y坐标
    lineHeight: 20, //文字的行高
    font: "24px 'Microsoft Yahei'", //文字样式
    text: "请修改掉默认的配置", //需要绘制的文本
    drawWidth: 320, //文字显示的宽度
    color: "#000000", //文字的颜色
    backgroundColor: "#ffffff", //背景颜色
  };

  //将传入的配置覆盖掉默认配置
  if (!!options && typeof options === "object") {
    for (var i in options) {
      settings[i] = options[i];
    }
  }

  //获取2d的上线文开始设置相关属性
  var canvas = settings.canvas;
  var scale = 2;
  canvas.width = Math.floor(settings.canvasWidth * scale);
  var ctx = canvas.getContext("2d");

  //绘制背景色
  ctx.fillStyle = settings.backgroundColor;
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  //绘制文字
  ctx.font = settings.font;
  ctx.fillStyle = settings.color;
  var lineWidth = 0; //当前行的绘制的宽度
  var lastTextIndex = 0; //已经绘制上canvas最后的一个字符的下标
  //由于改变canvas 的高度会导致绘制的纹理被清空，所以，不预先绘制，先放入到一个数组当中
  var arr = [];
  //换行拆分
  var multiText = settings.text;
  // while(multiText.indexOf('<a')){
  multiText = multiText.replace(/<a/g, "");
  multiText = multiText.replace(/>/g, "");
  multiText = multiText.replace(/<\/a/g, "");
  multiText = multiText.replace(/href=\"(.+?)\"/g, "");
  // }
  // console.log(multiText)
  multiText = multiText.split("<br");
  //循环每一行内容
  $.each(multiText, function(rowIndex, rowText) {
    //当前行的绘制的宽度
    lineWidth = 0; //当前行的绘制的宽度
    lastTextIndex = 0; //已经绘制上canvas最后的一个字符的下标
    for (var i = 0; i < rowText.length; i++) {
      var currentText = rowText.substr(lastTextIndex, i - lastTextIndex);
      //获取当前的截取的字符串的宽度
      lineWidth = ctx.measureText(currentText).width;

      if (lineWidth > settings.drawWidth) {
        //判断最后一位是否是标点符号
        if (judgePunctuationMarks(rowText[i - 1])) {
          arr.push(rowText.substr(lastTextIndex, i - lastTextIndex));
          lastTextIndex = i;
        } else {
          arr.push(rowText.substr(lastTextIndex, i - lastTextIndex - 1));
          lastTextIndex = i - 1;
        }
      }
      //将最后多余的一部分添加到数组
      if (i === rowText.length - 1) {
        arr.push(rowText.substr(lastTextIndex, i - lastTextIndex + 1));
      }
    }
  });

  //根据arr的长度设置canvas的高度
  canvas.height = Math.floor((arr.length * settings.lineHeight + settings.drawStartY) * scale);

  ctx.font = settings.font;
  ctx.fillStyle = settings.color;
  for (var i = 0; i < arr.length; i++) {
    ctx.fillText(arr[i], settings.drawStartX, settings.drawStartY + i * settings.lineHeight);
  }

  //判断是否是需要避开的标签符号
  function judgePunctuationMarks(value) {
    var arr = [".", ",", ";", "?", "!", ":", '"', "，", "。", "？", "！", "；", "：", "、"];
    for (var i = 0; i < arr.length; i++) {
      if (value === arr[i]) {
        return true;
      }
    }
    return false;
  }

  return canvas.toDataURL("image/png");
}


// WEBPACK FOOTER //
// ./utils/getGroupInfo.js